import React, { useState, useEffect } from "react";
import Auth from "../Auth";
import { Link } from "react-router-dom";

export default function Experiments() {
  const [experiments, setExperiments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchExperiments();
  }, []);

  const fetchExperiments = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await Auth.fetchWithIdToken("/api/admin/experiments", {});
      setExperiments(result.experiments || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: "20px" }}>
        <h1>Card Experiments</h1>
        <p>Loading experiments...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px" }}>
        <h1>Card Experiments</h1>
        <div style={{ color: "red", marginTop: "10px" }}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <h1>Card Experiments (Last 2 Weeks)</h1>
      <p style={{ color: "#666", marginBottom: "20px" }}>
        A/B Tests Involving Cards (anonymous_id is NOT null)
      </p>

      {experiments.length === 0 ? (
        <p>No experiments found in the last 2 weeks.</p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f5f5f5" }}>
              <th
                style={{
                  padding: "12px",
                  textAlign: "left",
                  borderBottom: "2px solid #ddd",
                }}
              >
                Experiment ID
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "left",
                  borderBottom: "2px solid #ddd",
                }}
              >
                Variations
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "right",
                  borderBottom: "2px solid #ddd",
                }}
              >
                Total Views
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "right",
                  borderBottom: "2px solid #ddd",
                }}
              >
                Users
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "left",
                  borderBottom: "2px solid #ddd",
                }}
              >
                Last Seen
              </th>
            </tr>
          </thead>
          <tbody>
            {experiments.map((exp) => (
              <tr key={exp.experimentId} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "12px" }}>
                  <Link
                    to={`/admin/experiments/${exp.experimentId}`}
                    style={{
                      color: "#0066cc",
                      textDecoration: "none",
                      fontWeight: "500",
                    }}
                  >
                    {exp.experimentId}
                  </Link>
                </td>
                <td style={{ padding: "12px" }}>
                  {exp.variations.map((v) => (
                    <span
                      key={v}
                      style={{
                        display: "inline-block",
                        padding: "4px 8px",
                        marginRight: "4px",
                        backgroundColor: "#e3f2fd",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {v}
                    </span>
                  ))}
                </td>
                <td style={{ padding: "12px", textAlign: "right" }}>
                  {exp.totalViews.toLocaleString()}
                </td>
                <td style={{ padding: "12px", textAlign: "right" }}>
                  {exp.userCount.toLocaleString()}
                </td>
                <td style={{ padding: "12px" }}>
                  {new Date(exp.lastSeen).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
